;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import {
  booleanEnvironmentSchema,
  requiredNumberEnvironment,
} from '@qogita/validation/environment'
import { requiredString } from '@qogita/validation/string'

export const NEXT_PUBLIC_SENTRY_ENABLED = booleanEnvironmentSchema()
  .default(false)
  .parse(process.env.NEXT_PUBLIC_SENTRY_ENABLED)

export const NEXT_PUBLIC_SENTRY_DSN = NEXT_PUBLIC_SENTRY_ENABLED
  ? requiredString('NEXT_PUBLIC_SENTRY_DSN missing from environment').parse(
      process.env.NEXT_PUBLIC_SENTRY_DSN,
    )
  : undefined

export const NEXT_PUBLIC_SENTRY_REPLAYS_SESSION_SAMPLE_RATE =
  NEXT_PUBLIC_SENTRY_ENABLED
    ? requiredNumberEnvironment(
        'NEXT_PUBLIC_SENTRY_REPLAYS_SESSION_SAMPLE_RATE missing from environment',
      ).parse(process.env.NEXT_PUBLIC_SENTRY_REPLAYS_SESSION_SAMPLE_RATE)
    : undefined

export const NEXT_PUBLIC_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE =
  NEXT_PUBLIC_SENTRY_ENABLED
    ? requiredNumberEnvironment(
        'NEXT_PUBLIC_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE missing from environment',
      ).parse(process.env.NEXT_PUBLIC_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE)
    : undefined
